import { Loader } from '@itandi/itandi-bb-ui';
import type React from 'react';
import { Page as Component } from '~/components/specifics/Page';
import { useCompanyStoreSettings } from '~/hooks/useCompanyStoreSettings';
import useItandiAccount from '~/hooks/useItandiAccount';

export const Page: React.FC = () => {
  const { data: currentAccount } = useItandiAccount().currentAccount();
  const { data: companyStoreSettings } = useCompanyStoreSettings().index();

  if (
    currentAccount === null ||
    currentAccount.store === null ||
    companyStoreSettings === null
  ) {
    return <Loader />;
  }

  return (
    <Component
      companyStoreSettings={companyStoreSettings}
      currentAccount={currentAccount}
      currentStore={currentAccount.store}
    />
  );
};
